// extracted by mini-css-extract-plugin
module.exports = {"result":"Result_result__fwMqx","result__icon":"Result_result__icon__zX4Mm","result__number":"Result_result__number__FnVmR","result__text":"Result_result__text__f4WFo"};